<div class="shipment-tracking">

  <div class="event-group">
    <div class="group-packages">
      @for (trackingNumber of this.packageTrackingNumbers; track trackingNumber) {
        <span class="package">
          {{ trackingNumber }}
        </span>
      }
    </div>
    @if (!displayPackageTracking) {
      <div class="group-packages">
        <span class="package" i18n>
                All Packages
            </span>
      </div>
    }
  </div>

  <div class="event-list">
    <div class="event-spacer">
      <div class="bar"></div>
    </div>
    @for (e of this.events; track e) {
      @if (e.showDate) {
        <div class="change date-change">
          <div class="bar"></div>
          <div class="indicator"></div>
          <div class="change-display">
            <div class="day">{{ e.day }}</div>
            <div class="month">{{ e.month }}</div>
          </div>
        </div>
      }
      @if (e.showCountry) {
        <div class="change country-change">
          <div class="bar"></div>
          <div class="indicator"></div>
          <div class="change-display">
            {{ e.country }}
          </div>
        </div>
      }
      @if (e.showLocation) {
        <div class="change location-change">
          <div class="bar"></div>
          <div class="indicator"></div>
          <div class="change-display">
            {{ e.location }}
          </div>
        </div>
      }
      <div class="event" [class.last]="e.last">
        <div class="bar"></div>
        <div class="icon"></div>
        <div class="time">{{ e.event.time }}</div>
        <div class="description">{{ e.event.description }}</div>
      </div>
    }
  </div>

  @if (groups.length > 0) {
    <div class="event-split">
      @for (g of groups; track g) {
        <div class="sub-group">
          <div class="join"
            [class.join-corner]="!g.first && g.last"
            [class.join-v]="g.first && !g.last"
            [class.join-h]="!g.first && !g.last">
            <div class="top">
              <div class="left"></div>
              <div class="right"></div>
            </div>
            <div class="bottom">
              <div class="left"></div>
              <div class="right"></div>
            </div>
          </div>
          <div class="group-container">
            <app-tracking-group [group]="g.group" [shipment]="shipment"></app-tracking-group>
          </div>
        </div>
      }
    </div>
  }

</div>

